import { Checkbox, Divider, Paper } from '@mui/material';
import { MemreButton, MemreFlexBox } from 'components/core';
import { MemreRTE } from 'components/core';
import type { Answer } from 'services/useItem.service/interactions';

export default function AnswerElement({ answer, handleAddImage }: { answer: Answer; handleAddImage: any }) {
  const disabled = answer.id.includes('placeholder');

  return (
    <Paper
      component="form"
      sx={{
        p: '2px 8px 2px 4px',
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #bbb',
        opacity: disabled ? 0.3 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      <Checkbox checked={answer.isCorrect} onChange={answer.toggle} />
      <MemreFlexBox direction="column" sx={{ flex: 1 }}>
        <MemreRTE
          initialContent={answer.text}
          onUpdate={answer.update}
          placeholder="Answer Text"
          id={`$answer-${answer.id}`}
        />
        <Divider orientation="horizontal" />
        <div style={{ margin: '-6px 0' }}>
          <MemreRTE
            initialContent={answer.explanation}
            onUpdate={answer.updateExplanation}
            id={`$explanation-${answer.id}`}
            placeholder="Explain why this is the correct/wrong answer (optional)"
          />
        </div>
      </MemreFlexBox>
      <Divider sx={{ height: '70%', m: 0.5 }} orientation="vertical" />
      {answer.image?.url && (
        <MemreFlexBox direction="column" sx={{ position: 'relative', height: '100%' }} align="center" justify="center">
          <div
            style={{
              aspectRatio: '1/1',
              height: '100%',
              backgroundImage: `url(${answer.image.url})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              borderRadius: '4px',
            }}
          />
          <MemreButton
            variant="icon"
            iconName="trash"
            onClick={answer.image.delete}
            sx={{ position: 'absolute', backgroundColor: 'white' }}
          />
        </MemreFlexBox>
      )}
      {!answer.image?.url && (
        <MemreButton variant="icon" iconName="image" onClick={() => handleAddImage(answer.image.add)} />
      )}
      <MemreButton variant="icon" iconName="trash" onClick={answer.delete} />
    </Paper>
  );
}
